// src/app/components/NavMenu.js
import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { ChevronDown } from "lucide-react";

const NavMenu = ({ items, open }) => {
  const [openMenus, setOpenMenus] = useState({});
  const location = useLocation();

  const toggleMenu = (label) => {
    setOpenMenus((prev) => ({
      ...prev,
      [label]: !prev[label],
    }));
  };

  const isChildActive = (children) => {
    return children?.some((child) => location.pathname.startsWith(child.path));
  };

  return (
    <ul className="space-y-1 px-2">
      {items.map((item, index) => (
        <React.Fragment key={item.label || item.path}>
          {item.divider && index > 0 && (
            <li className="my-4 border-t border-gray-200"></li>
          )}

          {/* SIMPLE MENU */}
          {!item.children && (
            <li>
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center px-4 py-3 rounded-lg transition-colors ${
                    isActive
                      ? "bg-blue-50 text-blue-600"
                      : "text-gray-700 hover:bg-gray-100"
                  }`
                }
              >
                <item.icon size={20} />
                {open && (
                  <span className="ml-3 text-sm font-medium">
                    {item.label}
                  </span>
                )}
              </NavLink>
            </li>
          )}

          {/* PARENT MENU */}
          {item.children && (
            <li>
              <button
                onClick={() => toggleMenu(item.label)}
                className={`w-full flex items-center justify-between px-4 py-3 rounded-lg transition-colors ${
                  isChildActive(item.children)
                    ? "bg-blue-50 text-blue-600"
                    : "text-gray-700 hover:bg-gray-100"
                }`}
              >
                <div className="flex items-center">
                  <item.icon size={20} />
                  {open && (
                    <span className="ml-3 text-sm font-medium">
                      {item.label}
                    </span>
                  )}
                </div>

                {open && (
                  <ChevronDown
                    size={16}
                    className={`transition-transform ${
                      openMenus[item.label] ? "rotate-180" : ""
                    }`}
                  />
                )}
              </button>

              {/* SUBMENU */}
              {open && (openMenus[item.label] || isChildActive(item.children)) && (
                <ul className="ml-8 mt-1 space-y-1">
                  {item.children.map((child) => (
                    <li key={child.path}>
                      <NavLink
                        to={child.path}
                        className={({ isActive }) =>
                          `block px-3 py-2 text-sm rounded-lg ${
                            isActive
                              ? "bg-blue-50 text-blue-600"
                              : "text-gray-600 hover:bg-gray-100"
                          }`
                        }
                      >
                        {child.label}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          )}
        </React.Fragment>
      ))}
    </ul>
  );
};

export default NavMenu;